import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  rippleContainer: {
    position: 'relative'
  }
});
export default useStyles;